import React, { Component } from 'react';
import GlslCanvas from 'glslCanvas';
import NotFoundShader from './Shaders/NotFoundShader.frag';
export default class NotFoundPage extends Component {

    
    componentDidMount(){
        const canvas = document.getElementById("notFoundCanvas");
        global.sandbox = new GlslCanvas(canvas);

    }

	render() {

        const dpr = window.devicePixelRatio;
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;

        const canvasSize = 320;

		return <div id="404_cont" style={{
			position:"absolute",
            backgroundColor: "#EBECEF",
            width: "100%",
            height: "100%",
            userSelect: "none",
            margin: 0
						
		}}>
            <canvas id="notFoundCanvas" data-fragment-url={NotFoundShader}
                width={canvasSize*dpr} height={canvasSize*dpr}
                style={{
                    position: "absolute",
                    width: canvasSize,
                    height: canvasSize,
                    left: (winWidth- canvasSize) / 2,
                    bottom: (winHeight - canvasSize) * 0.6,
                    
                }}></canvas>
                <h1 style={{
                    position: "absolute",
                    bottom: "calc( 60% - 48px )",
                    width: "100%",
                    textAlign: "center",
                    color: "white",
                }}>טעות בכתובת</h1>
                <a href="https://kayma.com/" target="blank" style={{
                    position: "absolute",
                    bottom: 60,
                    textAlign: 'center',
                    width: "100%"
                }}>kayma.com</a>
	  	</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/NotFoundPage.js